import PieChart from "./PieChart";
import ColumnChart from "./ColumnChart";
import RingChart from "./RingChart";
import DonutChart from "./DonutChart";
import ProgressBar from "./ProgressBar";
import ProgressReturningBar from "./ProgressReturningBar";
import ProgressCompareBar from "./ProgressCompareBar";

export default {
	PieChart,
	ColumnChart,
	RingChart,
	DonutChart,
	ProgressBar,
	ProgressCompareBar,
	ProgressReturningBar
};




// WEBPACK FOOTER //
// ./src/components/chart/index.js